import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NetworkService } from '../shared/network.service';
@Injectable({
  providedIn: 'root'
})
export class AuthServiceLocal {
  private pageChange = new BehaviorSubject('false');
  currentPage = this.pageChange.asObservable();

  constructor(private networkService: NetworkService,
    ) { }

  Page(message: string) {
    this.pageChange.next(message)
  }
  validateLogin(req: any) {
    return this.networkService.login("api/login", req, null, null);
  }
}
